import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IWarehouse } from '../../models/warehouses.models';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { AddWarehouse, AddWarehouseSuccess, UpdateWarehouse, UpdateWarehouseSuccess } from '../../store/warehouses.actions';
import { take, takeUntil } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';
import { selectIsSaving } from '../../store/warehouses.selectors';

declare var google: any;

@Component({
  selector: 'app-form-warehouse',
  templateUrl: './form-warehouse.component.html',
  styleUrls: ['./form-warehouse.component.scss']
})
export class FormWarehouseComponent {
  form!: FormGroup;
  warehouse!: IWarehouse;
  mode: 'create' | 'edit' = 'create';
  isSaving$ = this.store.select(selectIsSaving).pipe(takeUntil(this.actions$.pipe(ofType(AddWarehouseSuccess, UpdateWarehouseSuccess))));
  private autocomplete: any = null;
  constructor(
    private dialogRef: MatDialogRef<FormWarehouseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store<AppState>,
    private actions$: Actions,
  ) {
    this.warehouse = data.warehouse;
    this.mode = this.warehouse ? 'edit' : 'create';
    this.initForm();
    this.actions$.pipe(ofType(AddWarehouseSuccess, UpdateWarehouseSuccess), take(1)).subscribe(() => this.cancel());
    
  }

  initForm() {
    console.log(this.warehouse);
    this.form = new FormGroup({
      name: new FormControl({ value: this.warehouse?.name, disabled: this.warehouse?.read_only === true }, [Validators.required]),
      address: new FormControl({value: this.warehouse?.address?.name, disabled: this.warehouse?.read_only === true}, [Validators.required]),
      external_id: new FormControl({value: this.warehouse?.external_id, disabled: this.warehouse?.read_only === true}, []),
      city: new FormControl(this.warehouse?.address?.city, []),
      country_code: new FormControl(this.warehouse?.country?.code, []),
      country_name: new FormControl(this.warehouse?.country?.name, []),
      zip: new FormControl(this.warehouse?.address?.zip, [], ),
      street_number: new FormControl(this.warehouse?.address?.street_number, []),
      street: new FormControl(this.warehouse?.address?.street, []),
      is_primary: new FormControl(this.warehouse?.is_primary || false, []),
    });
  }
  
  addressAutoComplete(event: FocusEvent): boolean | void {
    const input = event.target as HTMLInputElement;

    if (!input) {
      console.error(`Element with id 'apartment' not found`);
      return;
    }

    const center = { lat: 50.064192, lng: -130.605469 };
    let options: any = {
      strictBounds: false,
      bounds: {
        north: center.lat + 0.1,
        south: center.lat - 0.1,
        east: center.lng + 0.1,
        west: center.lng - 0.1,
      },
      language: 'en',
    };

    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      if (!place) {
        console.error('No place found');
        return;
      }
      let region = '';
      let city = '';
      let streetNumber = '';
      let postalCode = '';
      let route = '';
      let country_code = '';
      let country_name = '';
      console.log(place);
      console.log(JSON.stringify(place));
      for (const component of place.address_components) {
        const types = component.types;
        if (types.includes('street_number')) {
          streetNumber = component.long_name;
          this.form.get("street_number")?.setValue(streetNumber);
        }

        if (types.includes('route')) {
          route = component.long_name;
          this.form.get("street")?.setValue(route);
        }

        if (types.includes('locality')) {
          city = component.long_name;
          this.form.get("city")?.setValue(city);
        }

        if (types.includes('postal_code')) {
          postalCode = component.long_name;
          this.form.get("zip")?.setValue(postalCode);
        }

        if (types.includes('country')) {
          country_code = component.short_name;
          country_name = component.long_name;
          this.form.get("country_code")?.setValue(country_code || '');
          this.form.get("country_name")?.setValue(country_name || '');
        }
      }
      const parts = [`${streetNumber} ${route}`.trim(), postalCode, city, region, country_name];
      const address = parts.filter(Boolean).join(', ');
      this.form.get("address")?.setValue(address);
    });
  }
  
  cancel(){
    this.dialogRef.close();
  }
  
  save(){
    if(this.form.invalid){
      this.form.markAllAsTouched();
      return;
    }
    const payload = {
      code: this.warehouse?.code,
      name: this.form.get('name')?.value,
      address: {
        name: this.form.get('address')?.value,
        street: this.form.get('street')?.value,
        street_number: this.form.get('street_number')?.value,
        city: this.form.get('city')?.value,
        zip: this.form.get('zip')?.value,
        country: {
          code: this.form.get('country_code')?.value,
          name: this.form.get('country_name')?.value,
        },
      },
      external_id: this.form.get('external_id')?.value,
      is_primary: this.form.get('is_primary')?.value,
    }
    if(this.mode === 'create'){
      this.store.dispatch(AddWarehouse({ warehouse: payload }));
    } else {
      this.store.dispatch(UpdateWarehouse({ id: this.warehouse.id, warehouse: payload }));
    }
  }
}
